<template>
  <div class="app-header">
    <img
      :src="languageKeys.LOGO_URL"
      @click="brandNavigate()"
    >
  </div>
</template>

<script>
import lang from '../language-keys';

export default {
  name: 'AppHeader',
  data: function () {
    return {
      languageKeys: {
        logoUrl: ''
      }
    };
  },
  mounted() {
    this.languageKeys = lang.getLanguageKeys();
    window.document.title = `${this.languageKeys.TITLE} | ${this.languageKeys.APP_NAME}`;
  },
  methods: {
    brandNavigate() {
      window.location = window.location.origin.replace('grants.', 'customer.');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-header {
  height: 58px;
  background: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: 0px 24px 0px 16px;
  position: relative;
}

.app-header img {
  cursor: pointer;
}

.app-header img {
  height: 35px;
}
</style>
